import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { BrowserModule } from '@angular/platform-browser';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgProgressModule } from '@ngx-progressbar/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ROUTES } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { WelcomePageComponent } from './components/welcome-page/welcome-page.component';
import { RollingPageComponent } from './components/rolling-page/rolling-page.component';
import { VerificationPageComponent } from './components/verification-page/verification-page.component';
import {
  VerificationTractorsPageComponent
} from './components/verification-tractors-page/verification-tractors-page.component';
import { VerificationDriversComponentPage } from './components/verification-drivers-page/verification-drivers-page.component';
import { CoveragePageComponent } from './components/coverage-page/coverage-page.component';
import { CoverageProposalPageComponent } from './components/coverage-proposal-page/coverage-proposal-page.component';
import {
  EnrollmentConfirmationPageComponent
} from './components/enrollment-confirmation-page/enrollment-confirmation-page.component';
import { SecurityService } from './services/securityService';
import { AuthenticationService } from './dataServices/authDataService';
import { HttpService } from './services/httpService';
import { ConfigService } from './services/configService';
import { AppState } from './services/app.service';
import { AppInitializer } from './AppInitializer';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { UserService } from './dataServices/userService';
import { ErrorsInterceptor } from './errors/interceptors/error.interceptor';
import { NotificationModule } from './notification/notification.module';
import { PdfReportService } from './services/pdfReport.service';
import { DriversService } from './services/drivers.service';
import { AuthGuardService } from './services/authGuardService';
import { AzureLoggerService } from './services/azureLoggerService';
import { ToastComponent } from './components/toast/toast.component';
import { DriversModalComponent } from './components/drivers-modal/drivers-modal.component';
import { ForgotPasswordPageComponent } from './components/forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './components/reset-password-page/reset-password-page.component';
import { ResetPasswordGuardService } from './services/resetPasswordGuardService';
import { HomePageComponent } from './components/home-page/home-page.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { DocumentsPageComponent } from './components/documents-page/documents-page.component';
import { DocumentsService } from './services/documents.service';
import { PoliciesAndRequestsPageComponent } from './components/policies-and-request-page/policies-and-request-page';
import { DatePipe } from '@angular/common';
import { AnalyticsPageComponent } from './components/analytics-page/analytics-page.component';
import { AnalyticsService } from './services/analytics.service';
import { FixedCurrencyPipe } from './pipes/fixedCurrencyPipe';
import { FixedPipe } from './pipes/fixedPipe';
import { FixedPercentPipe } from './pipes/fixedPercentPipe';

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    HomePageComponent,
    ErrorPageComponent,
    WelcomePageComponent,
    RollingPageComponent,
    VerificationPageComponent,
    VerificationTractorsPageComponent,
    VerificationDriversComponentPage,
    CoveragePageComponent,
    CoverageProposalPageComponent,
    EnrollmentConfirmationPageComponent,
    DriversModalComponent,
    ToastComponent,
    ForgotPasswordPageComponent,
    ResetPasswordPageComponent,
    DocumentsPageComponent,
    PoliciesAndRequestsPageComponent,
    AnalyticsPageComponent,
    FixedPipe,
    FixedCurrencyPipe,
    FixedPercentPipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES, {
      preloadingStrategy: PreloadAllModules
    }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatSortModule,
    NgProgressModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    NotificationModule,
    PdfViewerModule,
    NgSelectModule
  ],
  providers: [
    AppInitializer,
    SecurityService,
    AuthenticationService,
    UserService,
    HttpService,
    ConfigService,
    AppState,
    PdfReportService,
    DriversService,
    DocumentsService,
    AnalyticsService,
    AuthGuardService,
    ResetPasswordGuardService,
    AzureLoggerService,
    DatePipe,
    FixedPipe,
    FixedCurrencyPipe,
    FixedPercentPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: (app: AppInitializer) => () => app.Init(),
      deps: [AppInitializer],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
